'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _colors = require('HubStyleTokens/colors');

var _times = require('HubStyleTokens/times');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _CardContext = require('../context/CardContext');

var _Color = require('../core/Color');

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _UIDragHandle = require('../draggable/UIDragHandle');

var _UIDragHandle2 = _interopRequireDefault(_UIDragHandle);

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

var _AccordionTransition = require('../transitions/AccordionTransition');

var _AccordionTransition2 = _interopRequireDefault(_AccordionTransition);

var _Styles = require('../utils/Styles');

var _UICardHeader = require('./UICardHeader');

var _UICardHeader2 = _interopRequireDefault(_UICardHeader);

var _UICardSection = require('./UICardSection');

var _UICardSection2 = _interopRequireDefault(_UICardSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TRANSITION_ANIMATION_TIMEOUT = parseInt(_times.CARD_TRANSITION_ANIMATION_TIMING, 10);

var Outer = (0, _styledComponents2.default)(_UISection2.default).withConfig({
  displayName: 'UICardWrapper__Outer'
})(['position:relative;display:flex;flex-direction:column;width:100%;padding:0;background-color:', ';box-shadow:0 1px 5px 0 ', ';', ';'], _colors.OLAF, (0, _Color.rgba)(_colors.PANTERA, 0.12), (0, _Styles.setBorderRadius)());

var isDraggable = function isDraggable(child) {
  return child.type.displayName === _UIDragHandle2.default.displayName;
};

var isExpander = function isExpander(child) {
  var possibleHeader = child;
  if (_react2.default.isValidElement(child) && isDraggable(child)) {
    possibleHeader = child.props.children;
  }

  return _react2.default.isValidElement(possibleHeader) && possibleHeader.type === _UICardHeader2.default;
};

var isSection = function isSection(child) {
  return _react2.default.isValidElement(child) && child.type === _UICardSection2.default;
};

var renderExpandableChildren = function renderExpandableChildren(children, expanded, onExpandedChange) {
  var sawHeader = false;
  var output = _react.Children.map(children, function (child) {
    if (isExpander(child)) {
      sawHeader = true;
      return _react2.default.cloneElement(child, { expanded: expanded, onExpandedChange: onExpandedChange });
    }

    if (isSection(child)) {
      return _react2.default.createElement(
        _AccordionTransition2.default,
        {
          className: 'private-card__content-wrapper',
          open: expanded,
          duration: TRANSITION_ANIMATION_TIMEOUT
        },
        child
      );
    }

    return child;
  });

  if (process.env.NODE_ENV !== 'production') {
    if (!sawHeader) {
      var msg = 'UICardWrapper: Expandable behavior requires a UICardHeader child';
      _devLogger2.default.warn({ message: msg, key: msg });
    }
  }

  return output;
};

var UICardWrapper = (0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
      className = props.className,
      compact = props.compact,
      expandable = props.expandable,
      expanded = props.expanded,
      onExpandedChange = props.onExpandedChange,
      rest = _objectWithoutProperties(props, ['children', 'className', 'compact', 'expandable', 'expanded', 'onExpandedChange']);

  return _react2.default.createElement(
    Outer,
    _extends({}, rest, {
      className: (0, _classnames2.default)('private-card', 'private-card__wrapper', className, { 'private-card--compact': compact }),
      ref: ref
    }),
    _react2.default.createElement(
      _CardContext.CardContextProvider,
      {
        value: compact ? _CardContext.compactCardContext : _CardContext.defaultCardContext
      },
      expandable ? renderExpandableChildren(children, expanded, onExpandedChange) : children
    )
  );
});

UICardWrapper.propTypes = _extends({}, _UISection2.default.propTypes, {
  children: _propTypes2.default.node.isRequired,
  compact: _propTypes2.default.bool.isRequired,
  expanded: _propTypes2.default.bool,
  expandable: _propTypes2.default.bool,
  onExpandedChange: _propTypes2.default.func
});

UICardWrapper.defaultProps = _extends({}, _UISection2.default.defaultProps, {
  compact: false,
  expandable: false,
  expanded: true
});

UICardWrapper.displayName = 'UICardWrapper';

exports.default = (0, _Controllable2.default)(UICardWrapper, ['expanded']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/card/UICardWrapper.js
// module id = 593
// module chunks = 177